import { Calculator } from 'lucide-react'
import { FormulaCard } from './FormulaCard'

export const ReapproCategoriesFormulas = () => (
  <div className="mx-2 mt-4">
    <div className="flex items-center gap-2 mb-3">
      <Calculator size={14} className="text-primary" />
      <span className="text-sm text-muted-foreground">Formules des algorithmes</span>
    </div>
    <div className="grid grid-cols-3 gap-3">
      <FormulaCard
        label="VMAX"
        isActive
        color="#15803d"
        formulaText="Besoin = (VMAX × TauxCouv − StockActuel + StockDLC − StockArr) × CoefSécu × CoefWE"
      />
      <FormulaCard
        label="VMJ"
        isActive
        color="#2563eb"
        formulaText="Besoin = (VMJ × TauxCouv − StockActuel + StockDLC − StockArr) × CoefSécu × CoefWE"
      />
      <FormulaCard
        label="Stock Projeté"
        isActive
        color="#7c3aed"
        formulaText="Besoin = (Prévision × CoefSécu) − StockProjeté"
      />
    </div>
  </div>
)
